import React, { createContext, useContext, useEffect } from 'react';

import { httpClient } from '../api/httpClient';


const UserSettingsContext = createContext();

const UserSettingsProvider = ({ children }) => {
    const [data, setData] = React.useState();

    useEffect(() => {
        refreshData();
    }, []);

    const refreshData = () => (
        httpClient('personal-settings', {
            method: 'GET',
        }).then((res) => {            
            res.json && setData(res.json);
        })
    );

    const contextValue = { 
        data: data,
        refreshData: refreshData,
    };

    return (
        <UserSettingsContext.Provider value={contextValue}>
            {children}
        </UserSettingsContext.Provider>
    );
};

const useUserSettingsContext = () => {
    const context = useContext(UserSettingsContext);
  
    if (!context) {
        throw new Error('useUserSettingsContext must be used within an UserSettingsProvider');
    }
  
    return context;
};


export { UserSettingsProvider, useUserSettingsContext };